import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import EnableDisableButton from "components/Shared/EnableDisableButton";
import WarehousingBasicDetail from "./WarehousingComponents/WarehousingBasicDetail";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
    WarehousingDetailContext,
    useWarehousingDetailContext,
} from "contexts/WarehousingDetailContext";
import {
    useGetWarehousingDetailQuery,
    useUpdateWarehousingMutation,
} from "store/services/warehousingApi";
import WarehousingDetailTab from "./WarehousingComponents/WarehousingDetailTab";
import { useAuth } from "hooks";

const WarehousingDetailScreen = () => {
    const { id } = useParams();

    const breadcrumb = [
        { title: "Warehousing", path: "/app/crm/warehousing/list" },
        { title: "Warehousing Detail" },
    ];

    const {
        data: warehousingDetail,
        isLoading: loadingWarehousing,
        error,
    } = useGetWarehousingDetailQuery(id);

    return (
        <WarehousingDetailContext.Provider value={{ warehousingDetail, loadingWarehousing }}>
            <BreadcrumbLayout
                breadcrumbs={breadcrumb}
                isBusy={loadingWarehousing}
                headerActions={<PageActions />}
            >
                <BreadcrumbLayout.Error error={error} />
                <BreadcrumbLayout.Paper>
                    <WarehousingBasicDetail />
                    <Divider />
                    <WarehousingDetailTab />
                </BreadcrumbLayout.Paper>
            </BreadcrumbLayout>
        </WarehousingDetailContext.Provider>
    );
};

export default WarehousingDetailScreen;

const PageActions = () => {

    const { isAccountAdmin } = useAuth();

    const { warehousingDetail, loadingWarehousing } = useWarehousingDetailContext();

    const [updateWarehousing, { isLoading: updatingWarehousing }] =
        useUpdateWarehousingMutation();

    const handleToggleStatus = async () => {
        try {
            await updateWarehousing({
                _id: warehousingDetail._id,
                isActive: !warehousingDetail.isActive,
            }).unwrap();
            toast.info(`Warehousing ${warehousingDetail.isActive ? "Disabled" : "Enabled"}!`);
        } catch (error) {
            toast.error(error?.data?.message ?? "Could Not Update Status");
        }
    };

    return (
        <div className="flex space-x-4">
            {isAccountAdmin && (<EnableDisableButton
                isActive={warehousingDetail?.isActive}
                loading={loadingWarehousing || updatingWarehousing}
                onClick={handleToggleStatus}
            />)}
            <Link to={`/app/crm/warehousing/${warehousingDetail?._id}/edit`}>
                <Button startIcon={<EditOutlined />} variant="contained">
                    Edit
                </Button>
            </Link>
        </div>
    );
};
